// import { useEffect } from "react";
import Logo from "../../assets/images/header/Logo.svg";
// import { ModalOverlay, Modal, CloseBtn } from "./AsideMenu.styled";
import { CgCloseR } from "react-icons/cg";
import { IoIosPhonePortrait } from "react-icons/io";
import { TfiEmail } from "react-icons/tfi";
import styles from "./AsideMenu.module.scss";

export const AsideMenu = ({ isOpen, setIsOpen }) => {

  // useEffect(() => {
  //   const close = (e) => {
  //     console.log(e.key);
  //     if (e.key === "Escape") {
  //       setIsOpen(false);
  //     }
  //   };
  //   if (isOpen) {
  //     window.addEventListener("keydown", close);
  //     return () => window.removeEventListener("keydown", close);
  //   }
  // }, [isOpen]);
  const closeMenu = () => {
    setIsOpen(false);
  }

  const { modalOverlay, modalOverlay__hidden, modal, modal__hidden, closeBtn, aside__list, aside__item, aside__button } = styles;


  return (
    <>
      <div
        className={isOpen ? modalOverlay : modalOverlay__hidden}
        onClick={closeMenu}
      />
      <div className={isOpen ? modal : modal__hidden}>
        <button className={closeBtn}
          onClick={closeMenu}

        >
          <CgCloseR size={30} />
        </button>
        <div>
        <ul className={aside__list}>
          <li className={aside__item} onClick={closeMenu} >
            <a href="#header">
                <img src={Logo} height='60px' width='55px' alt="logo" />                            
            </a>
            </li>
          <li className={aside__item} onClick={closeMenu}>
            <a href="#about">O mnie</a>
          </li>
          <li className={aside__item} onClick={closeMenu}>
            <a href="#projects">Portfolio</a>
          </li>
          <li className={aside__item} onClick={closeMenu}>
            <a href="#contact">Kontakt</a>
          </li>
          <li className={aside__item} onClick={closeMenu}>
            <a href="tel:+514510313">
              <p><IoIosPhonePortrait />514-510-313</p>
            </a>
          </li>
          <li className={aside__item}>                        
            <a href="mailto:mierzejewski2you@gmail.com">
              <button className={aside__button} onClick={closeMenu}><TfiEmail />Napisz</button>
            </a>                        
          </li>
            </ul>
        </div>
      </div>
    </>
  );
};
